import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';

@Injectable({
    providedIn: 'root'
})
export class SnackBarService {

    private readonly snackBarConfig: MatSnackBarConfig;
    constructor(private snackBar: MatSnackBar) {
        this.snackBarConfig = new MatSnackBarConfig();
        this.snackBarConfig.duration = 2000;
        this.snackBarConfig.verticalPosition = 'top';
    }

    openSnackbar(message: string, customAction?: string, customConfig?: MatSnackBarConfig<any> ) {
        this.snackBar.open(message, customAction ?? 'Dismiss', customConfig ?? this.snackBarConfig);
    }
}
